<section class="block-faq" [style.background-color]="backgroundColor">
  <div class="container py-5">
    <div class="text-center mb-4">
      <h2
        class="block-faq__title titleTextFont"
        [style.color]="titlesColor"
      >{{ title }}</h2>
      <div
        class="block-faq__subtitle"
        [style.color]="secondaryColor"
      >{{ subtitle }}</div>
    </div>

    <div class="row" *ngIf="faqs.length > 0">
      <div class="col-lg-8 offset-lg-2">
        <div class="faq-item" *ngFor="let faq of faqs">
          <div class="row mb-4 pb-2 border-bottom">
            <div
              class="col-md-12 d-flex justify-content-between flex-center"
              [class.collapsed]="faq.collapsed"
              (click)="toggleCollapse(faq)"
            >
              <p class="title mt-2">{{ faq.title }}</p>
              <button class="btn btnRound btnToggler d-flex justify-content-center align-items-center">
                <img src="assets/images/mootiva/plus_icon.svg" width="20" height="20" loading="lazy" decoding="async">
              </button>
            </div>
          </div>
          <div class="row mb-4 fadeIn" *ngIf="faq.collapsed">
            <div class="col-md-12 description">
              <p>{{ faq.content }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div
      class="block-faq__actions d-flex flex-wrap mt-4"
      *ngIf="btn1Active || btn2Active"
    >
      <a
        *ngIf="btn1Active"
        [href]="btn1Link"
        class="btn btn-info btn-flex mr-3 mt-md-0 mt-2"
      >
        {{ btn1Text }}
        <i class="fa fa-arrow-right mx-2"></i>
      </a>
      <a
        *ngIf="btn2Active"
        [href]="btn2Link"
        class="btn-info-2 mr-2 mt-md-0 mt-2 py-2"
        [style.color]="linkColor"
      >
        {{ btn2Text }}
        <i class="fa fa-arrow-right mx-2"></i>
      </a>
    </div>
  </div>
</section>
